export const getAspectsAttributes = (data) => {
    if (!Array.isArray(data) || !data.length) {
        return {};
    }
    try {
        return {
            'data-aspects': JSON.stringify(data),
        };
    }
    catch (_) {
        return {};
    }
};
//# sourceMappingURL=dataAttributes.js.map